import React, { PureComponent } from "react";

import { Metric, Error } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class PocketWatchVideoAdRevenue extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row d-flex border-between-metrics pt-0 pb-0">
        <div className="col-12 col-md-4 pb-4 pb-md-0">
          <Heading size={6} className={"mb-2"}>
            Revenue This Month
          </Heading>
          <Metric {...data.revenue_this_month} size={"lg"} type={"currency"} />

          <div className="row mt-4">
            <div className="col">
              <Heading size={6} className={"mb-2"}>
                This Time Last Month
              </Heading>
              <Metric
                {...data.revenue_last_month}
                size={"md"}
                type={"currency"}
              />
            </div>
            <div className="col">
              <Heading size={6} className={"mb-2"}>
                Total for Last Month
              </Heading>
              <Metric
                {...data.revenue_total_last_month}
                size={"md"}
                type={"currency"}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4 mt-2 mt-md-0 mb-3 pl-0 pl-md-4 pb-4 pb-md-0">
          <Heading size={6} className={"mb-2"}>
            Requests This Month
          </Heading>
          <Metric {...data.requests_this_month} size={"lg"} />

          <div className="row mt-4 ">
            <div className="col">
              <Heading size={6} className={"mb-2"}>
                This Time Last Month
              </Heading>
              <Metric {...data.requests_last_month} size={"md"} />
            </div>
            <div className="col">
              <Heading size={6} className={"mb-2"}>
                Total for Last Month
              </Heading>
              <Metric {...data.requests_total_last_month} size={"md"} />
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4 mt-2 mt-md-0 mb-3 pl-0 pl-md-4 pb-4 pb-md-0">
          <Heading size={6} className={"mb-2"}>
            Impressions This Month
          </Heading>
          <Metric {...data.impressions_this_month} size={"lg"} />

          <div className="row mt-4">
            <div className="col">
              <Heading size={6} className={"mb-2"}>
                This Time Last Month
              </Heading>
              <Metric {...data.impressions_last_month} size={"md"} />
            </div>
            <div className="col">
              <Heading size={6} className={"mb-2"}>
                Total for Last Month
              </Heading>
              <Metric {...data.impressions_total_last_month} size={"md"} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PocketWatchVideoAdRevenue;
